<script>
    import SelectorWidget from './SelectorWidget.vue';

    export default {
        extends: SelectorWidget,
        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.options = data.items;
                this.setValue();
            }
        }
    }
</script>
